export default __webpack_public_path__ + "static/media/coverVideo.061a5b8c.mp4";